import Modal from "components/atoms/modal";
import { TextSm } from "components/atoms/text";
import Btn from "components/atoms/buttons";

interface Props {
  onClose: () => void;
}

// 면적 입력 안할 시 안내
const ModalGuideMeasure = ({ onClose }: Props) => {
  return (
    <Modal.Container className="w-[312px] p-10 rounded-16 text-center">
      <TextSm className="text-black-60% mb-5">적용면적을 입력해주세요.</TextSm>
      <Btn.Blue onClick={onClose} size="large" className="w-full">
        확인
      </Btn.Blue>
    </Modal.Container>
  );
};

export default ModalGuideMeasure;
